<template>
    <div :class="['StatChip', strong && 'strong', color && 'color', format === statFormats.CURRENCY && 'currency']">
        <div class="StatChip_box">
          <div v-if="label" class="StatChip_label">{{ label }}</div>
          <!-- <div class="StatChip_value" v-html="shortNums(value, format)"></div> -->
          <div class="StatChip_value" v-html="typeof value === 'string' ? value : shortNums(animatedValue, format)"></div>
        </div>

        <span v-if="chain" class="StatChip_chain">{{ chain }}</span>
    </div>
</template>

<script>
  import { STAT_FORMATS } from '@/constants';
  import anime from 'animejs/lib/anime.es.js';

  export default {
    name: 'StatChip',
    props: {
        label: String,
        value: {
            type: Number|String,
            default: 0
        },
        format: {
            type: String,
            default: STAT_FORMATS.DECIMAL,
        },
        strong: {
          type: Boolean,
          default: false
        },
        color: {
          type: Boolean,
          default: false
        },
        chain: {
          type: String,
          default: ''
        },
    },
    data () {
      return {
        statFormats: STAT_FORMATS,
        tweenedValue: 0,
      }
    },
    computed: {
      animatedValue: function() {
        return this.tweenedValue.toFixed(0);
      }
    },
    methods: {
      shortNums: function (value, format) {
        const formatter = new Intl.NumberFormat('en', { style: format, currency: 'USD', notation: 'compact', maximumFractionDigits: 1 });
        const percentDivider = format === STAT_FORMATS.PERCENT ? 100 : 1; //percent style requires a value between 0 - 1

        return formatter.format(isNaN(value) ? 0 : value / percentDivider).replace('$', '<sup class="sup">$</sup>').replace('.0', '');
      }
    },
    mounted() {
      this.tweenedValue = this.value;
    },
    watch: {
      value: function(newValue) {
        // this.tweenedValue = newValue;
        anime({
          targets: this.$data,
          tweenedValue: newValue,
          duration: 500,
          easing: 'linear',
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/scss/colors.scss';
  .StatChip{
    display: flex;
    justify-content: center;
    position: relative;
    &_label{
      font-size: 13px;
      color: $purple;
      display: block;
      font-weight: 500;
      line-height: 1;
      @media screen and (max-width: 960px) {
        font-size: 11px;
      }
    }
    &_value{
      font-size: 70px;
      color: #A0A0A0;
      display: inline-flex;
      align-items: flex-start;
      gap: 0.05em;
      font-weight: 300;
      line-height: 1;
      letter-spacing: -0.03em;
      @media screen and (max-width: 960px) {
        font-size: 50px;
      }
      .strong &{
        font-weight: 500;
      }
      .color &{
        color: $purple;
      }
      /deep/
      .sup{
        font-size: 0.3em;
        font-weight: 400;
        line-height: inherit;
        top: 0.5em;
      }
      .h-center-value &{
        display: flex;
        flex-direction: row;
        justify-content: center;
      }
    }
    &_chain{
      font-size: 28px;
      background: #FFFFFF;
      color: $purple;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border: 1px solid #E2E2E2;
      border-radius: 50%;
      font-weight: 500;
      position: absolute;
      top: calc(50% - 20px);
      right: -20px;
      z-index: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/StatChip.vue